export function shouldAutoStartGuided({
  savedListsLoading,
  savedListsError,
  searchCount,
  savedListCount,
}) {
  return !savedListsLoading
    && !savedListsError
    && searchCount === 0
    && savedListCount === 0;
}
